<div class="mt-4 bg-white px-4" *ngIf="!!(favoriteSchedules$ | async)?.length">
    <div
        class="flex h-12 items-center justify-between border-b border-solid border-[#0000001a] dark:border-contrast-yellow">
        <div class="text-xs font-semibold uppercase leading-4 text-[#414141] dark:text-contrast-yellow">
            {{ 'FAVORITE_SCHEDULE' | translate }}
        </div>
    </div>

    <rwidget-explore-favorite-schedule-item
        class="block border-b border-solid border-[#0000001a]"
        *ngFor="let favoriteSchedule of favoriteSchedules$ | async"
        [favoriteSchedule]="favoriteSchedule"></rwidget-explore-favorite-schedule-item>
</div>

<div
    class="mt-4 px-4 text-center font-semibold text-secondary dark:text-contrast-yellow"
    *ngIf="!(favoriteSchedules$ | async)?.length && !deviceStatus">
    {{ 'NO_FAVORITE_SCHEDULES_YET_MESSAGE' | translate }}
</div>
